import { Pipe, PipeTransform } from '@angular/core';
import { APIVerkooporderWithCompany } from '../APIVerkooporders';

@Pipe({
  name: 'salesorderSearch',
})
export class SalesorderSearchPipe implements PipeTransform {
  transform(items: APIVerkooporderWithCompany[], searchText: string): APIVerkooporderWithCompany[] {
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();

    return items.filter(salesorder => {
      const et = (salesorder.errorText ?? '').toLowerCase();
      const con = (salesorder.createdOrderNumber ?? '').toLowerCase();
      const ua = (salesorder.updatedAt ?? '').toLowerCase();
      const ub = (salesorder.updatedBy ?? '').toLowerCase();
      return (
        salesorder.ticketId.toString().includes(searchText) ||
        salesorder.createdAt.toString().toLowerCase().includes(searchText) ||
        salesorder.customerNumber.toLowerCase().includes(searchText) ||
        salesorder.companyName.toLowerCase().includes(searchText) ||
        et.includes(searchText) ||
        con.includes(searchText) ||
        ua.includes(searchText) ||
        ub.includes(searchText)
      );
    });
  }
}
